import CurrencyIcon from "@/components/icons/CurrencyIcon";
import React from "react";

const LastSection = ({ totalPrice, Context, t, push }) => {
  return (
    <div className="sticky bottom-0 z-[100] py-4 bg-white border-t overflow-hidden rounded-br-md shadow-[-2px_0px_10px_rgba(0,0,0,0.1)] w-full">
      <div className="flex items-center justify-between mx-4 mb-2">
        <h3 className="text-[16px] font-semibold">{t("Total Price")}</h3>
        <h4 className="flex items-center gap-2 text-[18px] font-semibold">
          <span>{Math.round(totalPrice)?.toLocaleString()}</span>
          <CurrencyIcon className="w-4 h-4" />
        </h4>
      </div>
      <div className="flex flex-col gap-2 px-4">
        <button
          onClick={() => {
            push("/cart");
            Context?.dispatch({ type: "cartModal", payload: "" });
          }}
          className="w-full h-[60px] p-2 font-semibold rounded-lg bg-[#EFEFEF]"
        >
          {t("GoToCartPage")}
        </button>
        <button
          onClick={() => {
            Context?.dispatch({ type: "cartModal", payload: "" });
          }}
          className="w-full h-[60px] p-2 font-semibold border rounded-lg bg-[#0058D4] text-white"
        >
          {t("ContinueShopping")}
        </button>
      </div>
    </div>
  );
};

export default LastSection;
